import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Modal, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { apiGetOrgunit, apiGetOrgunits } from "../../api/ApiOrgunit";
import { apiGetPersonnes } from "../../api/ApiPersonnes";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import BlocSousOrgunit from "../../components/public/orgunit/BlocSousOrgunit";
import BlocValeurAjoutee from "../../components/public/orgunit/BlocValeurAjoutee";
import PersonneCard from "../../components/public/personne/PersonneCard";
import CompomentLien from "../../components/public/orgunit/ComponentLien";
import CompomentOrgunitCalendrier from "../../components/public/orgunit/CompomentOrgunitCalendrier";
import { MdOutlineEmail, MdBuild, MdPeople, MdManageAccounts, MdOutlineEdit } from "react-icons/md";
import { SiMicrosoftteams } from "react-icons/si";
import ComponentToaster from "../../components/layout/ComponentToaster";
import PersonneCardList from "../../components/public/personne/PersonneCardList";
import { apiGetAllContribByUsersByEspaces, apiGetLastContribByUsers } from "../../api/ApiColidee";
import { apiGetProcesses } from "../../api/ApiProcess";
import ComponentOrgunitColidee from "../../components/public/orgunit/ComponentOrgunitColidee";
import ComponentColideeButtonEspaces from "../../components/public/orgunit/ComponentColideeButtonEspaces";
import ModalChoixPersonnes from "../../components/admin/orgunit/ModalChoixPersonnes";
import ModalChoixProcesses from "../../components/admin/orgunit/ModalChoixProcesses";
import ModalCreateUpdate from "../../components/admin/orgunit/ModalCreateUpdate";
import { FaTag, FaBookmark } from "react-icons/fa";
import ModalChoixEngagements from "../../components/admin/orgunit/ModalChoixEngagements";

const PageOrgunit = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  let { id } = useParams();
  const [orgunit, setOrgunit] = useState("");
  const [personnes, setPersonnes] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [infoView, setInfoView] = useState(false);
  const [contributions, setContributions] = useState([]);
  const [allContributions, setAllContributions] = useState([]);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [showPersonnes, setShowPersonnes] = useState(false);
  const [showEngagements, setShowEngagements] = useState(false);
  const [showProcesses, setShowProcesses] = useState(false);
  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [enSommeil, setEnSommeil] = useState(false);
  const [orgunits, setOrgunits] = useState([]);
  const [controlPopupContact, setControlPopupContact] = useState(false);
  const [controlPopupLiens, setControlPopupLiens] = useState(false);

  useEffect(async () => {
    await recupOrgunits();
    recupOrgunit();
  }, [id, infoView]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupOrgunit = async () => {
    const res = await apiGetOrgunit(ReduxInstance._id, id);
    if (res.data) {
      if (!res.data.enSommeil) {
        setOrgunit(res.data);
        recupPersonnesInOrgunits();
      } else setEnSommeil(true);
    } else {
      console.log("error");
    }
  };

  const recupPersonnesInOrgunits = async () => {
    let res = "";
    if (infoView === false) {
      res = await apiGetPersonnes(ReduxInstance._id, "include=marque&filter[orgUnitsParent]=" + id);
    }
    if (infoView === true) {
      res = await apiGetPersonnes(
        ReduxInstance._id,
        "include=orgUnitsParent,marque,localisations&filter[orgUnitsParent]=" + id,
      );

      if (ReduxInstance.espacePrincipalColidee !== 0) {
        recupContributions(res.data);
      }
      recupAllContributionsForUsersOnAllEspaces(res.data);
    }

    if (res) {
      setPersonnes(res.data);
    } else {
      console.log("error");
    }
  };

  const genereMailingList = () => {
    let mailingList = "";
    personnes.forEach((element) => {
      if (element.email) {
        mailingList += element.email + ";";
      }
    });
    navigator.clipboard.writeText(mailingList);
    setShowToast(true);
    //return "mailto:" + mailingList;
  };

  const genereTeamsList = () => {
    let mailingList = "";
    personnes.forEach((element) => {
      if (element.email) {
        mailingList += element.email + ",";
      }
    });
    return "https://teams.microsoft.com/l/chat/0/0?users=" + mailingList;
  };

  const DetailFrequence = (props) => {
    const { frequence, detailFrequence } = props;

    const jours = [
      t("commun.jours.dimanche"),
      t("commun.jours.lundi"),
      t("commun.jours.mardi"),
      t("commun.jours.mercredi"),
      t("commun.jours.jeudi"),
      t("commun.jours.vendredi"),
      t("commun.jours.samedi"),
    ];

    const mois = [
      t("commun.mois.janvier"),
      t("commun.mois.fevrier"),
      t("commun.mois.mars"),
      t("commun.mois.avril"),
      t("commun.mois.mai"),
      t("commun.mois.juin"),
      t("commun.mois.juillet"),
      t("commun.mois.aout"),
      t("commun.mois.septembre"),
      t("commun.mois.octobre"),
      t("commun.mois.novembre"),
      t("commun.mois.decembre"),
    ];

    let recurrence = "";

    if (detailFrequence) {
      detailFrequence.forEach((element) => {
        if (frequence === "Hebdomadaire") {
          recurrence += " - " + jours[element];
        }
        if (frequence === "Mensuel") {
          recurrence += " - le " + element;
        }
        if (frequence === "Annuel") {
          recurrence += " - " + mois[element];
        }
      });
    }

    return recurrence;
  };

  const recupContributions = async (personnesArray) => {
    if (ReduxInstance.espacePrincipalColidee) {
      const myForm = new FormData();
      myForm.append("espacePrincipalColidee", ReduxInstance.espacePrincipalColidee);
      personnesArray.forEach((element) => {
        myForm.append("email[]", element.email);
      });

      const res = await apiGetLastContribByUsers(ReduxToken, myForm);
      if (res.data) {
        personnesArray.forEach((element) => {
          let personneFound = res.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
          if (personneFound === -1) {
            res.data.push({
              email: element.email,
              contribution: "Non renseigné",
            });
          }
        });

        setContributions(res.data);
      } else {
        console.log("error");
      }
    }
  };

  const recupAllContributionsForUsersOnAllEspaces = async (personnesArray) => {
    const myForm = new FormData();

    personnesArray.forEach((element) => {
      myForm.append("email[]", element.email);
    });

    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces)),
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    /* Si j'ai un espace RDV missions alors je ne le prends pas en compte pour trouver la derniere contrib sur tous les espaces */
    if (ReduxInstance.espacePrincipalColidee !== 0) {
      espacesSouhaites = espacesSouhaites.filter(
        (item) => parseInt(item) !== parseInt(ReduxInstance.espacePrincipalColidee),
      );
    }

    if (espacesSouhaites.length) {
      myForm.append("espacesSouhaites", espacesSouhaites.join(","));
      const resAllContributions = await apiGetAllContribByUsersByEspaces(ReduxToken, myForm);

      if (resAllContributions.data) {
        personnesArray.forEach((element) => {
          let personneFound = resAllContributions.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
          if (personneFound === -1) {
            resAllContributions.data.push({
              email: element.email,
              contribution: "Non renseigné",
            });
          }
        });

        setAllContributions(resAllContributions.data);
      } else {
        console.log("error");
      }
    }
  };

  /* UTILE POUR LES ADMINISTRATEURS */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const handleClosePopupContact = () => {
    setControlPopupContact(false);
  };

  const handleClosePopupLiens = () => {
    setControlPopupLiens(false);
  };

  const handleShowPersonnes = (id) => {
    setShowPersonnes(true);
  };

  const handleClosePersonnes = () => {
    setShowPersonnes(false);
    recupPersonnesInOrgunits();
  };

  const handleShowEngagements = (id) => {
    setShowEngagements(true);
  };

  const handleCloseEngagements = () => {
    setShowEngagements(false);
  };

  const handleShowProcesses = (id) => {
    setShowProcesses(true);
  };

  const handleCloseProcesses = () => {
    setShowProcesses(false);
  };

  const handleShowCreateUpdate = () => {
    recupOrgunits();
    setShowCreateUpdate(true);
  };
  const handleCloseCreateUpdate = () => {
    recupOrgunit();
    setShowCreateUpdate(false);
  };
  const recupOrgunits = async () => {
    const res = await apiGetOrgunits(ReduxInstance._id);
    if (res) {
      setOrgunits(res.data);
    }
  };
  /* FIN  UTILE POUR LES ADMINISTRATEURS */

  return (
    <>
      <ComponentMenu />
      {enSommeil && <div className="text-center m-5">{t("public.componentOrgUnit.enSommeil")}</div>}
      {orgunit && !enSommeil && (
        <Container className="mb-5">
          <div className="d-flex align-items-end">
            <div className="flex-grow-1">
              <ComponentTitle title={orgunit.nom} />
            </div>
            <div className="mb-4 d-flex align-items-center">
              {personnes.length > 0 && (
                <span
                  role="button"
                  className="ms-2 me-2 buttonCard btn btn-primary"
                  onClick={() => {
                    setControlPopupContact(true);
                  }}
                >
                  {t("public.componentOrgUnit.contacter")}
                </span>
              )}
              {orgunit.liens.length > 0 && (
                <span
                  role="button"
                  className="ms-2 me-2 buttonCard btn btn-primary"
                  onClick={() => {
                    setControlPopupLiens(true);
                  }}
                >
                  {t("public.componentOrgUnit.outils")}
                </span>
              )}

              {isAdminEasygouv() && (
                <NavDropdown
                  className="ms-2 me-2 float-end"
                  id="configurateurAdminPublic"
                  title={<MdBuild name="home" size="1.3em" role="button" />}
                >
                  <NavDropdown.Item
                    role="button"
                    onClick={() => handleShowCreateUpdate(orgunit._id)}
                  >
                    <MdOutlineEdit size="1.5em" /> {t("admin.PageAdminOrgunits.titreColonne5")}
                  </NavDropdown.Item>
                  <NavDropdown.Item role="button" onClick={() => handleShowPersonnes(orgunit._id)}>
                    <MdPeople size="1.5em" /> {t("admin.PageAdminOrgunits.titreColonne4")}
                  </NavDropdown.Item>
                  <NavDropdown.Item role="button" onClick={() => handleShowProcesses(orgunit._id)}>
                    <MdManageAccounts size="1.5em" /> {t("admin.PageAdminOrgunits.titreColonne3")}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    role="button"
                    onClick={() => handleShowEngagements(orgunit._id)}
                  >
                    <FaTag size="1.2em" /> {t("admin.PageAdminOrgunits.titreColonne10")}
                  </NavDropdown.Item>
                </NavDropdown>
              )}
            </div>
          </div>
          {orgunit.descriptionReelle !== "" && (
            <div style={{ whiteSpace: "pre-wrap" }}>{orgunit.descriptionReelle}</div>
          )}
          {orgunit.frequence !== "" && (
            <div>
              {t("public.componentOrgUnit.type1")}{" "}
              {orgunit.frequence === "Hebdomadaire" &&
                t("public.componentOrgUnit.frequenceHebdomadaire")}
              {orgunit.frequence === "Mensuel" && t("public.componentOrgUnit.frequenceMensuel")}
              {orgunit.frequence === "Annuel" && t("public.componentOrgUnit.frequenceAnnuel")}{" "}
              <DetailFrequence
                frequence={orgunit.frequence}
                detailFrequence={orgunit.detailFrequence}
              />
            </div>
          )}

          {ReduxInstance.calendrier && (
            <CompomentOrgunitCalendrier
              nomOrgunit={orgunit.nom}
              enfantsOrgunit={orgunits.filter((orgunit) => orgunit.orgUnitParent === id)}
              reduxInstanceId={ReduxInstance._id}
            />
          )}
          {personnes.length !== 0 && (
            <>
              <div className="flex-grow-1">
                <ComponentTitle
                  title={t("public.componentOrgUnit.membres")}
                  overflowID={"overflowMembres"}
                  infoView={infoView}
                  setInfoView={setInfoView}
                  afficheBoutonGrille="true"
                  emulateH2="true"
                  liensParticipationColidee={orgunit.liens.filter(
                    (item) => item.icone === "colidee",
                  )}
                  etiquetteAnimateur="true"
                />
              </div>

              <div className="d-flex overflowContent" id={"overflowMembres"}>
                {!infoView &&
                  personnes.map((personne, key) => (
                    <PersonneCard personne={personne} key={personne._id} />
                  ))}

                {infoView && (
                  <PersonneCardList
                    personnes={personnes}
                    infoView={infoView}
                    contributions={contributions}
                    allContributions={allContributions}
                  />
                )}
              </div>
            </>
          )}
          {orgunit.liens.filter((item) => item.icone === "colidee").length > 0 && (
            <ComponentOrgunitColidee
              liensColidee={orgunit.liens.filter((item) => item.icone === "colidee")}
            />
          )}
          <BlocSousOrgunit orgunitParent={orgunit._id} />
          <BlocValeurAjoutee
            ReduxInstanceId={ReduxInstance._id}
            idOrgunit={orgunit._id}
            nomOrgunit={orgunit.nom}
            descriptionOrgunit={orgunit.description}
            refreshDemande={showProcesses}
          />

          <ModalChoixPersonnes
            show={showPersonnes}
            idOrgUnit={orgunit._id}
            orgunitName={orgunit.nom}
            handleClose={handleClosePersonnes}
            ReduxInstanceId={ReduxInstance._id}
          />
          <ModalChoixEngagements
            show={showEngagements}
            idOrgUnit={orgunit._id}
            orgunitName={orgunit.nom}
            handleClose={handleCloseEngagements}
            ReduxInstanceId={ReduxInstance._id}
          />
          <ModalChoixProcesses
            show={showProcesses}
            idOrgUnit={orgunit._id}
            orgunitName={orgunit.nom}
            handleClose={handleCloseProcesses}
            ReduxInstanceId={ReduxInstance._id}
          />
          <ModalCreateUpdate
            show={showCreateUpdate}
            id={orgunit._id}
            handleClose={handleCloseCreateUpdate}
            handleRecupDatas={recupOrgunits}
            orgUnits={orgunits}
            refreshDemande={showCreateUpdate}
          />

          <Modal
            show={controlPopupContact}
            onHide={handleClosePopupContact}
            className="modalContact"
          >
            <Modal.Header closeButton>
              <Modal.Title>Contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                onClick={() => {
                  genereMailingList();
                }}
              >
                <MdOutlineEmail size="1.7em" role="button" className="m-2" />{" "}
                {t("public.componentOrgUnit.contactMail")}
                <ComponentToaster
                  message={t("commun.mailing")}
                  showToast={showToast}
                  setShowToast={setShowToast}
                  delay="5000"
                />
              </div>

              <a href={genereTeamsList()} target="_blank" rel="noreferrer">
                <SiMicrosoftteams size="1.5em" className="m-2" />{" "}
                {t("public.componentOrgUnit.contactTeams")}
              </a>
            </Modal.Body>
          </Modal>
          <Modal show={controlPopupLiens} onHide={handleClosePopupLiens} className="modalLiens">
            <Modal.Header closeButton>
              <Modal.Title>{t("public.applicationsExternes.outils")}</Modal.Title>
            </Modal.Header>

            {orgunit.liens.map((item, index) => (
              <CompomentLien icone={item.icone} url={item.url} nom={item.nom} key={index} />
            ))}
          </Modal>
        </Container>
      )}
    </>
  );
};

export default PageOrgunit;
